import React from 'react'
import { useMutation } from 'react-query'
import { Deal } from 'scenes/Dashboard/data/deals/types'
import { QueryStatus } from 'utils-next/api'
import { ExtendableStyles } from 'utils-next/types'

import { FormControlLabel, Switch } from '@mui/material'

import { useDealHandlers } from './DealCard.container'

export type DealIsCalibrationProps = ExtendableStyles & {
  deal: Deal
}

export function DealIsCalibration({ deal, ...otherProps }: DealIsCalibrationProps) {
  const { updateDealCalibrationStatus } = useDealIsCalibrationHandlers(deal)
  const { status, mutate: handleChange } = useMutation(updateDealCalibrationStatus)

  return (
    <FormControlLabel
      control={
        <Switch
          checked={deal.isCalibration}
          onChange={(_, checked) => {
            handleChange(checked)
          }}
        />
      }
      label="Calibration company"
      disabled={status === QueryStatus.loading}
      {...otherProps}
    />
  )
}

function useDealIsCalibrationHandlers(deal: Deal) {
  const { updateDealData } = useDealHandlers(deal.id)
  const updateDealCalibrationStatus = (checked: boolean) => {
    return updateDealData({ ...deal, isCalibration: checked })
  }
  return {
    updateDealCalibrationStatus,
  }
}
